module.exports = __webpack_public_path__ + "img/pass.dc6b7f67.png";